//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FieldMixin from './FieldMixin.js'; 

export default {

	mixins: [FieldMixin],

	components: {
		'VueQuantityInput': B2BPortal.Vue.Components.QuantityInput
	},

	props: {
		value: {
			type: Number | String,
			default: 1
		},
	},

	data()
	{
		return {
			quantity: parseFloat(this.product.ratio, 10)
		};
	},

	mounted() 
	{
		this.eventBus.$on('clearQuantity', itemId => {
			if (itemId == this.product.id)
				this.quantity = this.product.ratio;
		});	
	},

	methods: {

		checkQuantity()
		{
			if(!Number.isFinite(this.quantity))
			{
				this.quantity = this.product.ratio;
			}
			else
			{
				const newQuantity = Math.round((this.quantity + Number.EPSILON) * 100) / 100;
				if (newQuantity <= this.ratio)
					this.quantity = this.ratio;
				else if (newQuantity !== this.quantity)
					this.quantity = newQuantity;
			}

			if(!this.isEnoughInstock)
				this.quantity = this.product.inStock > 0 ? this.product.inStock : this.product.ratio;
		}

	},

	computed: {
		eventBus()
		{
			return this.$root.$eventBus || this;
		},

		inStock()
		{
			return parseFloat(this.product.inStock, 10);
		},

		isEnoughInstock() 
		{
			return !this.product.checkQuantity ||
				!(this.product.checkQuantity && this.quantity > this.inStock);
		},

		ratio()
		{
			return Number(this.product.ratio);
		}
	},

	watch: {

		product()
		{
			this.checkQuantity();
		},

		quantity()
		{
			this.$emit('input', this.quantity);
		}
		
	}
}
